import type { LpuDocument } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import type { CoreImageLightboxItem } from 'src/core/CoreImageLightbox/types'

/**
 * Изображения лицензии для полноэкранного просмотра.
 *
 * В слайдер попадают только документы с `doc_type.translit = document`.
 */
export default function getLicenseImages(
  images: LpuDocument[] | undefined,
  title: string,
): CoreImageLightboxItem[] {
  return (images ?? [])
    .filter(image => image.doc_type?.translit === 'document' && Boolean(image.img_l?.url))
    .map((image, index) => ({
      id: image.id ?? index,
      src: image.img_l?.url || '',
      alt: title,
      title,
    }))
}
